module.exports = __webpack_public_path__ + "img/Pattern06.a54cdf7f.png";